import React from 'react'
import LeftBarMenu from './LeftBarMenu'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Outlet } from 'react-router-dom'
import Error404 from '../404'
import { ErrorBoundary } from 'react-error-boundary'

const Layout = (): JSX.Element => {
  return (
    <div className={'min-h-screen w-screen flex flex-col relative'}>
      <main className={'h-full'}>
        <div className="flex">
          <div className={'print:hidden'}>
            <LeftBarMenu />
          </div>
          <main
            className={
              'min-h-screen bg-white min-w-full xl:min-w-[calc(100vw_-_247px)] xl:ml-[247px] print:ml-0 print:min-w-full'
            }>
            <ErrorBoundary FallbackComponent={Error404}>
              <div className={'min-h-screen h-full w-full'}>
                <Outlet />
              </div>
            </ErrorBoundary>
          </main>
        </div>
      </main>
      {import.meta.env.VITE_SHOW_QUERY_DEV_TOOLS && (
        <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />
      )}
    </div>
  )
}

export default Layout
